import * as XLSX from 'xlsx';

const headers = ['purchase_order_id', 'item_id', 'product_name', 'qty', 'no_of_units', 'actual_unit_price', 'unit_mrp', 'mfg_date', 'exp_date', 'sku_id', 'inventory_remarks'];

export const downloadPurchaseVerificationCsv = (po, items) => {
  const rows = items.map(item => headers.map(key => {
    if (key === 'purchase_order_id') return po.id;
    if (key === 'item_id') return item.id;
    return item[key] ?? '';
  }));
  const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const blob = new Blob(['\uFEFF', XLSX.utils.sheet_to_csv(sheet)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `purchase-${String(po.po_number || po.id).replace(/[^a-zA-Z0-9_-]/g, '_')}-verification.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

export const importPurchaseVerificationCsv = (text, po, items) => {
  const book = XLSX.read(text.replace(/^\uFEFF/, ''), { type: 'string', raw: true });
  const data = XLSX.utils.sheet_to_json(book.Sheets[book.SheetNames[0]], { header: 1, defval: '', blankrows: false });
  const columns = (data.shift() || []).map(value => String(value).trim());
  for (const key of headers) {
    if (!columns.includes(key)) throw new Error(`Missing CSV column: ${key}`);
  }
  if (data.length !== items.length || !items.length) throw new Error('Upload must contain exactly one row for every purchase item.');
  const seen = new Set();
  const imported = new Map();
  const validDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
  data.forEach((values, index) => {
    const row = Object.fromEntries(columns.map((key, i) => [key, String(values[i] ?? '').trim()]));
    const fail = message => { throw new Error(`CSV row ${index + 2}: ${message}`); };
    const item = items.find(candidate => String(candidate.id) === row.item_id);
    if (row.purchase_order_id !== String(po.id) || !item) fail('item does not belong to this purchase.');
    if (seen.has(row.item_id)) fail('duplicate item.');
    seen.add(row.item_id);
    for (const key of ['qty', 'no_of_units', 'actual_unit_price', 'unit_mrp']) {
      const number = Number(row[key]);
      if (!row[key] || !Number.isFinite(number) || (key === 'actual_unit_price' ? number < 0 : number <= 0)) fail(`invalid ${key}.`);
    }
    if (!Number.isInteger(Number(row.no_of_units))) fail('no_of_units must be a whole number.');
    if (!validDate(row.exp_date)) fail('exp_date must be a valid YYYY-MM-DD date.');
    if (row.mfg_date && (!validDate(row.mfg_date) || row.mfg_date > row.exp_date)) fail('mfg_date must be valid and on or before expiry.');
    const code = String(item.product_code || item.productCode || `MKP${item.product_id || item.id}`).replace(/\s+/g, '');
    imported.set(row.item_id, {
      ...item,
      qty: Number(row.qty), no_of_units: Number(row.no_of_units),
      actual_unit_price: Number(row.actual_unit_price), unit_mrp: Number(row.unit_mrp),
      mfg_date: row.mfg_date || null, exp_date: row.exp_date,
      sku_id: row.sku_id || `${code}-${row.exp_date.replace(/-/g, '')}`,
      inventory_remarks: row.inventory_remarks || null, is_verified: true,
    });
  });
  return items.map(item => imported.get(String(item.id)));
};
